import { EXPIRED, NOT_READY } from '@wwe-portal/web/utils/constants/offer';
import { useTranslations } from 'next-intl';
import React, { memo, useEffect, useState } from 'react';
import WebCoinShopBannerMobileWrapper from '../offer-card-banner/offer-card-banner-mobile-wrapper';
import { Button } from '@wwe-portal/ui/components/button';
import { Each } from '@wwe-portal/ui/components/utils/each';
import { OfferData } from '@wwe-portal/entities/offer.type';
import ShopOfferCardMobile from './offer-card-mobile';
import WebCoinShopBannerMobile from '../offer-card-banner/offer-card-banner-mobile';

const initialLimit = 3;
const limitToAdd = 5;

function ShopOfferCardMobileWrapper({
  offers,
  offerType,
  handlePurchase,
  transactionStarted,
  buttonText,
  hasWebCoinPrice = false,
  ruby = false,
  webcoin = false,
}) {
  /**
   * Set the offer feature for the details page
   */
  const [activeFeature, setActiveFeature] = useState<any>();
  /**
   * Show: Boolean
   */
  const [show, setShow] = useState(false);
  /**
   * List of offers
   */
  const [list, setList] = useState(offers);
  /**
   * Count of offers to show
   */
  const [index, setIndex] = useState(
    offerType === 'featured' ? initialLimit * 2 : initialLimit
  );
  /**
   * Translations
   */
  const t = useTranslations();

  useEffect(() => {
    let filteredOffers = [];

    switch (offerType) {
      case 'daily':
        filteredOffers = offers.filter((daily) => {
          if (daily.PortalAvailability && !daily.StockQuantity) {
            return false;
          } else return daily;
        });
        break;
      case 'featured':
      case 'rubies':
      case 'cash-packs':
      case 'tournament':
      case 'rewards':
        filteredOffers = offers?.filter(
          (item) =>
            (item.StockQuantity && item.Availability !== EXPIRED) ||
            item.Availability === NOT_READY
        );
        break;
      case 'web-coin':
        filteredOffers = offers?.filter(
          (item) => item.StockQuantity && item.Availability !== EXPIRED
        );
        break;
      default:
        return;
    }

    setList(filteredOffers ?? []);

    return () => {
      setList([]);
    };
  }, [index, offerType, offers]);

  const handleViewAll = () => {
    setIndex(index + limitToAdd);
  };

  const handleInfoModalOpenState = (feature) => {
    setActiveFeature(feature);

    if (feature) {
      setShow(true);
    }
  };

  return (
    <>
      <WebCoinShopBannerMobileWrapper
        open={show}
        onClose={() => setShow(false)}
      >
        <WebCoinShopBannerMobile
          offer={activeFeature}
          offerType={offerType}
          onHandlePurchase={handlePurchase}
          transactionStarted={transactionStarted}
          isInFuture={activeFeature?.Availability === NOT_READY}
          closeCallback={() => setShow(false)}
          titleText={buttonText}
          hasProgress
          isInModal
          price={
            activeFeature?.Price &&
            activeFeature.defaultCurrency &&
            activeFeature.Price?.[activeFeature.defaultCurrency]
              ? activeFeature.Price?.[activeFeature.defaultCurrency]
              : 0
          }
          webCoinPrice={activeFeature?.AlternativeCostAmount}
          hasWebCoinPrice={hasWebCoinPrice}
          ruby={ruby}
          webcoin={webcoin}
          index={index}
        />
      </WebCoinShopBannerMobileWrapper>

      <Each
        data={list?.slice(0, index) ?? []}
        render={(feature: OfferData, index) => (
          <div key={index} className="mw-xl-20 mb-[10px] p-0">
            <ShopOfferCardMobile
              transactionStarted={transactionStarted}
              handlePurchase={handlePurchase}
              handleInfoModalOpenState={handleInfoModalOpenState}
              data={feature}
              offerType={offerType}
              price={
                feature.Price &&
                feature.defaultCurrency &&
                feature.Price?.[feature.defaultCurrency]
                  ? feature.Price?.[feature.defaultCurrency]
                  : 0
              }
              webCoinPrice={feature.AlternativeCostAmount}
              hasWebCoinPrice={hasWebCoinPrice}
            />
          </div>
        )}
      />

      {list?.length > 3 && index < list.length ? (
        <Button
          onClick={() => handleViewAll()}
          variant="secondary"
          className="bg-back200 mt-[10px] flex h-10 w-full items-center justify-center rounded-md border-0 py-[10px] text-base font-semibold text-white"
        >
          {t('view_more')}
        </Button>
      ) : null}
    </>
  );
}

export default memo(ShopOfferCardMobileWrapper);
